import { render } from "./setpt.vue?vue&type=template&id=6be82654"
import script from "./setpt.vue?vue&type=script&lang=js"
export * from "./setpt.vue?vue&type=script&lang=js"

import "./setpt.vue?vue&type=style&index=0&id=6be82654&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__